<template>
  <my-currency
    v-model="internalValue"
    :required="required"
    v-bind="$attrs"
    v-on="$listeners"
    @focus="onFocus"
  />
</template>

<script>
import MyCurrency from './MyCurrency.vue'
import homeMixin from '../mixins/Home'

export default {
  name: 'DiscountCurrency',
  mixins: [homeMixin],
  components: { MyCurrency },
  props: {
    value: { type: [String, Number], default: '' },
    required: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
    discountLabel: { default: '' },
    route: { type: String, default: '' },
    base: { type: Number, default: 10000 }
  },
  data() {
    return {
      internalValue: this.sanitize(this.value)
    }
  },
  watch: {
    value(newVal) {
      const cleaned = this.sanitize(newVal)
      if (cleaned !== this.internalValue) this.internalValue = cleaned
    },
    internalValue(newVal) {
      const cleaned = this.sanitize(newVal)
      if (cleaned !== newVal) this.internalValue = cleaned
      this.$emit('input', cleaned)
    }
  },
  methods: {
    sanitize(val) {
      let cleaned = String(val ?? '').replace(/\D/g, '')
      return cleaned.slice(0, 15)
    },
    onFocus() {
      const numericValue = Number(this.internalValue)

      // فقط وقتی internalValue خالی یا کمتر/مساوی صفر است محاسبه شود
      if (isNaN(numericValue) || numericValue <= 0) {
        const discount = this.calculateDiscount({
          total: this.total,
          base: this.base,
          discountLabel: this.discountLabel,
          route: this.route,
          sanitize: this.sanitize
        })
        const sanitized = this.sanitize(discount)
        this.internalValue = sanitized
        this.$emit('input', sanitized)
      }

      this.$nextTick(() => {
        const el = this.$el.querySelector('input')
        if (el) el.select()
      })
    }
  }
}
</script>
